module.exports = __webpack_public_path__ + "8ea2657f263b6b2a404bfb57f4160013.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-ExtraLight.ttf
// module id = 1254
// module chunks = 0